import { render, staticRenderFns } from "./SeminarRowTest.vue?vue&type=template&id=5b830686&scoped=true&"
import script from "./SeminarRowTest.vue?vue&type=script&lang=js&"
export * from "./SeminarRowTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b830686",
  null
  
)

export default component.exports